<div class="container mt-0 flex-auto flex-col">
    <div class="sticky top-0 z-10  dark:bg-gray-900">
  
        <table class="w-full table-fixed mat-elevation-z" mat-table [dataSource]="dataSource" matSort
            (matSortChange)="changeSort($event)" matSortDisableClear multiTemplateDataRows>
  
            <ng-container matColumnDef="det">
                <th mat-header-cell *matHeaderCellDef style="min-width: 40px; width: 70px;"></th>
                <td mat-cell *matCellDef="let element">
                  <button class="h-7 min-h-7 min-w-10 px-2 leading-6" 
                  (click)="toggleDetails(element)" style="margin-left: 10px;">
                      <mat-icon class="icon-size-5"
                          [svgIcon]="selectedUnifiedOrderItem?.serial === element.serial
                              ? 'heroicons_solid:chevron-up' : 'heroicons_solid:chevron-down' "></mat-icon>
                  </button>
                </td>
            </ng-container>
  
            <ng-container matColumnDef="route">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle">Pedido Unificado</th>
                <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
                  <p class="table-text-m" style="min-width: 102px;">
                    <span class="table-text-code">
                      {{ element.serial ?? '-' }}<br> <!-- {{ element.route?.code ?? '-' }}-->
                    </span>
                  </p>
                </td>
            </ng-container>
  
            <ng-container matColumnDef="quantity">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left first-col table-tittle"># Pedidos</th>
              <td mat-cell *matCellDef="let element" class="text-left first-col table-text">
                <p class="table-text-m" style="min-width: 102px;">
                  <span class="table-text-code">
                    {{ element.quantity ?? '-' }}<br>
                  </span>
                </p>
              </td>
            </ng-container>
          
            <ng-container matColumnDef="weight">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class=" text-left first-col table-tittle text-right">
                  <span class="table-text-m-2">Carga</span>
                </th>
                <td mat-cell *matCellDef="let element" class=" text-left first-col table-text">
                  <p class="table-text-m-2">
                    {{ (element?.weight ?? 23.3 | weightFormat:'lbs') }}
                  </p>
                </td>
            </ng-container>

            <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                <tr *ngIf="selectedUnifiedOrderItem?.serial === element.serial" class="details-row">
                    <td [attr.colspan]="displayedColumns.length">
                        <ng-container *ngTemplateOutlet="rowDetailsTemplate; context: { $implicit: element }"></ng-container>
                    </td>
                </tr>
            </ng-container>
  
            <!-- Header Row -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky top-0 z-10  bg-white shadow-md shadow-gray-700/10 dark:bg-gray-900"></tr>
            <!-- Fila principal -->
            <tr id="datarow" mat-row *matRowDef="let element; columns: displayedColumns;" class="border-b "
            [ngClass]="{
              'bg-gray-100 hover:bg-gray-100 border-b-2 border-gray-100 mdc-data-table__row--selected' : selectedUnifiedOrderItem?.serial === element.serial,
            }"
            [class.table-expanded-row]="selectedUnifiedOrderItem?.serial === element.serial"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="table-detail-row"></tr>
        </table>
    </div>
    <div *ngIf="this.dataSource.data.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">Lo sentimos, no hay registros para mostrar.
    </div>

</div>
  
  
<ng-template #rowDetailsTemplate let-element>
  <div class="pl-6">
    <app-order-table [ordersData]="selectedUnifiedOrderItem.sourceTransactions" [displayedColumns]="['det', 'serial', 'weight']"
    [loadCalculationMode]="loadCalculationMode" [UMPActive]="UMPActive"
    ></app-order-table>
  </div>
</ng-template>

<ng-template #noData>
  <span>
    -
  </span>
</ng-template>